import TFFTypography from '../../../styled-components/TFFTypography';
import { useBookingContext } from '../../../hooks/use-booking-context';

interface props {
  segmentName: string;
  time: string;
}

export const NdcFlightPathAttributes: React.FC<props> = ({ segmentName, time }) => {
  const { timeFormatter, dateFormatter, weekdayFormatter } = useBookingContext();
  const date = new Date(time);

  return (
    <div style={{ gap: '8px', display: 'flex' }}>
      <TFFTypography text={segmentName} color="color-functional-neutral-900" />
      <TFFTypography text={timeFormatter.format(date)} color="color-functional-neutral-900" fontWeight="bold" />
      <TFFTypography
        text={`${weekdayFormatter.format(date)}. ${dateFormatter.format(date)}`}
        color="color-functional-neutral-900"
        extraClassName="tff-text-no-wrap"
      />
    </div>
  );
};
